/**
 * POST /api/v1/users/:userId/activate | /deactivate
 * Shared for AGENT, BROKERAGE_AGENT, SIGNAGE_TEAM_MEMBER, BROKERAGE_TEAM_MEMBER.
 */
export async function postUserLicenseToggle(
  token: string | null | undefined,
  userId: string,
  action: "activate" | "deactivate"
): Promise<{ ok: boolean; message: string }> {
  if (!token) {
    return { ok: false, message: "Session expired. Please login again." };
  }
  const id = String(userId || "").trim();
  if (!id) {
    return { ok: false, message: "Invalid user ID" };
  }
  const base = process.env.REACT_APP_API_URL || "";
  const url = `${base}/users/${encodeURIComponent(id)}/${action}`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  const result: { error?: string; message?: string } = await response.json().catch(() => ({}));
  const errMsg = String(result?.error || result?.message || "").trim();
  if (!response.ok) {
    return { ok: false, message: errMsg || `Request failed (${response.status})` };
  }
  if (result && typeof result === "object" && "error" in result && result.error) {
    return { ok: false, message: errMsg || "Request failed" };
  }
  const okMsg = String(result?.message || "").trim();
  return {
    ok: true,
    message:
      okMsg ||
      (action === "activate"
        ? "User activated successfully"
        : "User deactivated successfully"),
  };
}
